<div class="page cover full-size">
  <div class="main d-flex flex-column flex-grow-1">
    <app-cover-title></app-cover-title>
    <app-cover-main [showAgentInfo]="showAgentInfo"></app-cover-main>
  </div>
</div>
